// extracted by mini-css-extract-plugin
export default {"mask":"UoMIY_mask","content":"N35ut_content"};